<template>
    <card>
      <div class="row" style="margin-top: 10px;">
        <div class="col-6">
          <h5>Location: <code style="font-size: 16px">{{weather.name}}</code></h5>
        </div>
        <div class="col-6">
          <base-input style="float: right">
            <select v-model="location" @change="getLocation" class="form-control">
              <option value="current">Current Location</option>
              <option value="project">Project's Location</option>
            </select>
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h5>{{new Date().toDateString()}} <code style="font-size: 16px">{{getTime}}</code></h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h5>Condition: <code style="font-size: 16px">{{weather.weather[0].description}}</code></h5>
        </div>
      </div>
      <div class="row" style="margin-top: 38px">
        <div class="col-6">
          <div class="row">
            <div class="col-12" style="text-align: center;">
              <i :class="getIcons(weather.weather[0].main, new Date().toString())" :style="getFontSizeTemp(2)"></i>
            </div>
          </div>
          <div class="row" style="margin-top: 10px">
            <div class="col-12" style="text-align: center;">
              <code :style="getFontSizeTemp(1)">{{Math.round(weather.main.temp)}}°F</code>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-12">
              <h5 class="description">Pressure: <code style="font-size: 12px">{{weather.main.pressure}}hPa</code></h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h5 class="description">Humidity: <code style="font-size: 12px">{{weather.main.humidity}}%</code></h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h5 class="description">Wind speed: <code style="font-size: 12px">{{weather.wind.speed}}MPH</code></h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h5 class="description">Feels like: <code style="font-size: 12px">{{Math.round(weather.main.feels_like)}}F</code></h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h5 class="description">Temperature min: <code style="font-size: 12px">{{Math.round(weather.main.temp_min)}}F</code></h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h5 class="description">Temperature max: <code style="font-size: 12px">{{Math.round(weather.main.temp_max)}}F</code></h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h5 class="description">Cloudiness: <code style="font-size: 12px">{{weather.clouds.all}}%</code></h5>
            </div>
          </div>
        </div>
      </div>
    </card>
</template>

<script>
  import { getIcon } from "../../plugins/weatherSettings";
    export default {
      props: ['weather'],
      name: "CurrentWeatherCard",
      data(){
        return{
          location: 'current',
          currentChecked: true,
        }
      },
      methods:{
        getFontSizeTemp(k){
          const w = window.innerWidth;
          const size = (w < 600)? k*40 : k*46;
          return {'font-size': size + 'px'};
        },
        getIcons(con, time){
          return getIcon(con, time)
        },
        getLocation(){
          this.$emit('change-location', this.location)
        },
      },
      computed:{
        getTime(){
          const res = new Date().toLocaleString().split(' ')[1].split(':');
          return res[0] + ':' + res[1];
        },
      },
    }
</script>

<style scoped>
  .row{
    margin-top: -10px;
  }
  .description{
    float: right;
  }
</style>
